import { render, staticRenderFns } from "./SummaryCardSwitch.vue?vue&type=template&id=83c810fa&lang=pug"
import script from "./SummaryCardSwitch.vue?vue&type=script&lang=js"
export * from "./SummaryCardSwitch.vue?vue&type=script&lang=js"
import style0 from "./SummaryCardSwitch.vue?vue&type=style&index=0&id=83c810fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports